import eventHandling from "js/src/tito/eventHandling.js";
import store from "js/src/store";

export default async function (item) {
  let path = item[1].event;
  let discountCodes = item[1].discountCodes;
  let releases = item[1].releases;
  let rsvp = item[1].rsvp;
  let source = item[1].source;
  let callback = item[2];
  let error;

  if (typeof callback === "function") {
    window.tito.notifiers.event[path] = window.tito.notifiers.event[path] || [];
    window.tito.notifiers.event[path].push(callback);
  }

  if (!path) {
    error = `Please specify which event you want the widget to load e.g. <tito-widget event="awesomeconf/${new Date().getFullYear()}">`;
  } else if(!path.includes("/")) {
    error = `The '${path}' event parameter you have set on the widget is not valid. The format should be ':account_slug/:event_slug' e.g. 'awesomeconf/${new Date().getFullYear()}'`;
  }

  if(error) {
    console.error(error);
    alert(error);
    return;
  }

  const event = await store
    .dispatch("event/get", {
      path: path,
      discountCodes: discountCodes,
      releases: releases,
      rsvp: rsvp,
      source: source
    })
    .catch((error) => {
      if (/status code 404/.test(error.message)) {
        let message = `Cannot connect to event '${path}'. Please check if the widget event parameter is correct and that the event is live.`;
        console.warn(message);
        alert(message);
      } else {
        console.error(error);
        alert(error.response.data.hint);
      }
    });
  if (event) {
    eventHandling.fire("widget:loaded", event);
  }
}
